module.exports = __webpack_public_path__ + "static/media/contact-information.faa41143.svg";